import { Modal } from "reactstrap";

const ExitPopup = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} centered className="exit-banner">
      <div className="content">
        <p className="alpha">
          Done reading? Let&apos;s get you to the right holster
        </p>
        <p className="subtitle">Choose your Holster and Complete Your Setup</p>
        <a href="/holsters?utm_source=exitbanner-web" className="catalog-link">
          Explore now
        </a>
        <button
          type="button"
          className="exit-banner-close-button"
          onClick={onClose}
        >
          &times;
        </button>
      </div>
    </Modal>
  );
};

export default ExitPopup;
